import { render } from "./SidebarMenuItemCounter.vue?vue&type=template&id=67df1c54&scoped=true"
import script from "./SidebarMenuItemCounter.vue?vue&type=script&lang=js"
export * from "./SidebarMenuItemCounter.vue?vue&type=script&lang=js"

import "./SidebarMenuItemCounter.vue?vue&type=style&index=0&id=67df1c54&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67df1c54"]])

export default __exports__